import axiosInstance from '@/utils/api.js'

var state = {
  changeLog: []
}

var getters = {

  CHANGE_LOG: (state) => {
    return state.changeLog
  }
}

var mutations = {
  SET_CHANGE_LOG: (state, payload) => {
    state.changeLog = payload
  }
}

var actions = {
  GET_CHANGE_LOG: async (context, payload) => {
    let result = await axiosInstance.get('/reports/users_log?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&action_id=' + payload.selectTypeUsers +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_CHANGE_LOG', result.data)
    }
  },
  CLEAR_CHANGE_LOG: (context) => {
    context.commit('SET_CHANGE_LOG', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/changeLog.js